import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";
import axios from "axios";
export const getGeneralEducationMonitoring = createAsyncThunk<
  any,
  {
    partner_id?: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("general/education/monitoring/school", async (data) => {
  try {
    const response = await CAxios.post(
      `${baseUrlApi}general/education/monitoring/school`,
      data
    );
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getSubjects = createAsyncThunk("subjects", async () => {
  try {
    const response = await CAxios.get(`subjects`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});

export const getAcademicYears = createAsyncThunk(
  "beneficiary/academic/years",
  async () => {
    try {
      const response = await CAxios.get(`beneficiary/academic/years`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const addEducationMonitoring = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("general/education/monitoring", async (data) => {
  try {
    const response = await CAxios.post(`general/education/monitoring`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response?.data;
  } catch (error) {
    throw error;
  }
});

//get universities monitoring
export const getUniversitiesMonitoring = createAsyncThunk<
  any,
  {
    partner_id?: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("education/monitoring/universities", async (data) => {
  try {
    const response = await CAxios.post(
      `${baseUrlApi}education/monitoring/universities`,
      data
    );
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

//get academic levels
export const getAcademicLevels = createAsyncThunk(
  "beneficiary/academic/levels",
  async () => {
    try {
      const response = await CAxios.get(`beneficiary/academic/levels`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// to add university monitoring
export const addUniversityMonitoring = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("education/monitoring", async (data) => {
  try {
    const response = await CAxios.post(
      `${baseUrlApi}education/monitoring`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response?.data;
  } catch (error) {
    throw error;
  }
});
//get universities
export const getUniversities = createAsyncThunk(
  "scholarship/getUniversities",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}scholarship/university`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
